<template>
	<qvoNavbar :navlist="navlist"/>
</template>

<script>
	/**
	 * @fileoverview navbar.vue displays a navigation bar using the qvoNavBar component.
	 * It relies on the qux-common code.
	 * 
	 * @components
	 * 		qvoNavbar - navigation bar component from the common code
	 * 
	 * @author David Barnett <david.barnett@quavo.com>
	 */
	import qvoNavbar from '@/qux-common/components/navbar.vue';

	export default {
		name: 'navbar',
		components: {
			qvoNavbar
		},
        data() {
            return {
				/**
				 * Navigation list
				 */
                navlist: [
                    {
                        linkTo: '/configuration',
                        label: 'Configuration'
                    },
                    {
                        linkTo: '/account',
                        label: 'Account'
                    }
                ]
            };
        }
	}
</script>

<!-- Styles defined in _titlebar.scss -->